import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import makeRootReducer from "./reducers";
import routeChange from "./middlewares/RouteChange";
import { browserHistory } from "./history";
import { isDevToolsExtensionEnabled } from "config";

const initialState = window.___INITIAL_STATE__;

export const creatingStore = () => {
  // ======================================================
  // Middleware Configuration
  // ======================================================

  const middleware = [thunk, routeChange];
  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = [];
  if (isDevToolsExtensionEnabled) {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
    if (typeof devToolsExtension === "function") {
      enhancers.push(devToolsExtension());
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createStore(
    makeRootReducer(),
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
  store.asyncReducers = {};

  if (module.hot) {
    module.hot.accept("./reducers", () => {
      const reducers = require("./reducers").default;
      store.replaceReducer(reducers);
    });
  }

  return store;
};

const store = creatingStore();

export { store, browserHistory };
